import * as React from 'react';
import { styles } from './styles';
import { ColorTypes } from '@joykit/variables/colors';

export type GrowLoaderProps = {
  orientation: Orientation;
  color: string | ColorTypes;
};

type Orientation = 'horizontal';

class GrowLoader extends React.PureComponent<GrowLoaderProps> {
  static defaultProps = {
    orientation: 'horizontal',
    color: '#333'
  };

  render(): React.ReactNode {
    return <div className={styles.container(this.props.color)} />;
  }
}

export { GrowLoader };
